import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';

import * as S from './ElitePackageCard.styles';
import {appConfig} from '@stencil/hotels-config';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import ViewRoomDetailsChunk from '../../../../../../stories/components/hotels/DetailsPageUnif/Rooms/ViewRoomDetails/ViewRoomDetailsChunk';
import useCarousel from '../../../../../hooks/useCarousel';
import PlanDetailsPoliciesModal from '../../../../../../stories/components/hotels/DetailsPageUnif/Rooms/Modal/PlanDetailsandPoliciesModal';
import CheckAvailabilityBtnUI from '../../../../../../stories/components/hotels/DetailsPageUnif/CheckAvailabilityAltAcco/CheckAvailabilityBtnUI';
import {useState} from 'react';
import {isDatePickRequiredSelector} from '@stencil/hotels-common-reducer/src/selectors';
import {useDispatch, useSelector} from 'react-redux';
import {isAltAccoUrlPropsSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';
import useNavigateToReviewPage from '@stencil/navigate-to-review-page-dweb';
import {omnitureConfig, omnitureThunk} from '@stencil/omniture-analytics';
import {
  DetailsPageComponents,
  detailsClick,
} from '@stencil/omniture-analytics/src/constants/details';
import {getInclusionIcon} from '@stencil/hotels-utils/src/name-to-icon-map-food';

const FCZPN = 'FCZPN';

const ElitPackageContainerUI = ({data = {}, handlOpenCalendar = () => {}}) => {
  const [navigatorNew] = useNavigateToReviewPage();
  const dispatch = useDispatch();

  const {rupeeString} = appConfig;
  const [planpolicyModalData, setPlanPolicyModalData] = useState({});
  const {isModalOpen, openModal, closeModal} = useModal();

  const isDatePickRequired = useSelector(isDatePickRequiredSelector);
  const isAltAccoUrlProps = useSelector(isAltAccoUrlPropsSelector);

  const {
    isModalOpen: isPlanPoliciesModalOpen,
    openModal: openPlanPoliciesModal,
    closeModal: closePlanPoliciesModal,
  } = useModal();

  const {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(data?.images, 1);

  const getRatePlanInfo = ({ratePlan = {}}) => {
    const bookAtInfo = ratePlan?.inclusionsList.find(item => item.type === FCZPN);
    const inclusionsToShow = ratePlan?.inclusionsList.filter(item => item.type !== FCZPN);
    return {bookAtInfo, inclusionsToShow};
  };

  const onMoreInfoClickHandler = () => {
    openModal();
  };

  const onViewPlanDetailsPoliciesClick = ({roomData}) => {
    setPlanPolicyModalData(roomData);

    openPlanPoliciesModal();
  };

  const onSelectPackageClick = descBlockInput => {
    const {rootLevelInfo, ...selectedRoomData} = descBlockInput;
    navigatorNew({
      selectedRoomInfo: [
        {
          ...selectedRoomData,
        },
      ],
      rootLevelInfo: {
        ...rootLevelInfo,
      },
    });

    dispatch(
      omnitureThunk(omnitureConfig.pages.RoomSelectionPageUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: detailsClick.roomSelection.elitePackageSelect,
          type: omnitureConfig.ctaType.Card,
          componentName: DetailsPageComponents.ElitePackages,
          destination: '',
        },
      }),
    );
  };

  return (
    <>
      <S.ContentWrapper>
        <S.ContentLeftWrapper>
          <S.RoomTypeHeader>{data?.roomName}</S.RoomTypeHeader>
          <S.RoomInfoWrapper>
            {!!data?.images?.length ? <S.RoomImg src={data?.images?.[0]} /> : null}

            <S.RoomInfoLeftWrapper>
              <S.RoomInfoList>
                {data?.roomHighlights?.slice(0, 4)?.map((item, idx) => {
                  return (
                    <S.RoomInfoListItem key={item?.descriptiondx}>
                      <img src={item?.iconUrl} />
                      <S.RoomInfoListItemDesc>{item.text}</S.RoomInfoListItemDesc>
                    </S.RoomInfoListItem>
                  );
                })}
              </S.RoomInfoList>
              <S.MoreInfoCta onClick={onMoreInfoClickHandler}>+ More Info</S.MoreInfoCta>
            </S.RoomInfoLeftWrapper>
          </S.RoomInfoWrapper>
        </S.ContentLeftWrapper>
        {data?.ratePlans?.map((ratePlan, idx) => {
          const {
            name: roomName,
            inclusionsList = [],
            tariffs,
            cancellationPolicy,
            cancellationPolicyTimeline,
          } = ratePlan;

          const tariff = tariffs?.[0];
          const {showPrice, tnc, slashedPrice, finalPriceKey} = getSlashAndShowPriceCg(tariff);

          const {bookAtInfo, inclusionsToShow} = getRatePlanInfo({ratePlan});

          return (
            <>
              <S.ContentMiddleWrapper>
                <S.RoomFeatureHeader>{roomName}</S.RoomFeatureHeader>
                <S.FeaturesList>
                  {inclusionsToShow?.slice(0, 4)?.map((item, idx) => {
                    return (
                      <S.FeaturesListItem key={idx}>
                        <S.ElitePackageFeatureIconWrapper>
                          {item?.iUrl || item?.iconUrl ? (
                            <img src={item?.iUrl || item?.iconUrl} />
                          ) : (
                            getInclusionIcon(item?.iconType, {
                              width: '0.8rem',
                              height: '0.8rem',
                              fill: '#18A160',
                              margin: '0 0.7rem 0 0.4rem',
                            })
                          )}
                        </S.ElitePackageFeatureIconWrapper>
                        <S.ElitePackageFeatureDesc
                          dangerouslySetInnerHTML={{
                            __html: item?.text || '',
                          }}
                        />
                      </S.FeaturesListItem>
                    );
                  })}
                </S.FeaturesList>
                <S.ViewMoreCta
                  onClick={() =>
                    onViewPlanDetailsPoliciesClick({
                      roomData: {
                        amenities: inclusionsList,
                        cancellationPolicy,
                        cancellationPolicyTimeline,
                        roomFlavorName: roomName,
                        roomTypeNameData: data?.roomName,
                      },
                    })
                  }
                >
                  View Details
                </S.ViewMoreCta>
              </S.ContentMiddleWrapper>
              <S.ContentRightWrapper>
                {!!slashedPrice && slashedPrice > showPrice ? (
                  <S.RoomPrice>
                    {rupeeString}
                    {slashedPrice}
                  </S.RoomPrice>
                ) : null}
                <S.OfferPrice>
                  {rupeeString}
                  {showPrice}
                </S.OfferPrice>
                <S.TaxText>
                  + {rupeeString}
                  {tnc} taxes & fees
                </S.TaxText>
                <S.TaxText>Room per night</S.TaxText>
                {bookAtInfo?.text && <S.BNPLCta>{bookAtInfo?.text}</S.BNPLCta>}
                {/* {handlOpenCalendar} */}
                {isDatePickRequired && isAltAccoUrlProps ? (
                  <S.ButtonWrapper>
                    <CheckAvailabilityBtnUI handlOpenCalendar={handlOpenCalendar} />
                  </S.ButtonWrapper>
                ) : (
                  <S.SelectRoomBtn
                    onClick={() =>
                      onSelectPackageClick({
                        ratePlanArr: [{...ratePlan}],
                        roomLevelInfo: {roomCode: data?.roomCode},
                        rootLevelInfo: {searchType: 'E', promoCode: finalPriceKey},
                      })
                    }
                  >
                    SELECT
                  </S.SelectRoomBtn>
                )}
              </S.ContentRightWrapper>
            </>
          );
        })}
      </S.ContentWrapper>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          height: '90vh',
          width: '84rem',
        }}
        CloseButton={() => null}
      >
        <ViewRoomDetailsChunk
          roomDescription={data?.description}
          roomTypeName={data?.roomName}
          amenities={data?.amenities}
          roomImages={dataList} // roomImages
          closeModal={closeModal}
          onRightArrowClick={increment}
          onLeftArrowClick={decrement}
          showLeftArrow={isLeftCursorActive}
          showRightArrow={isRightCursorActive}
          leftCursor={leftCursor}
          rightCursor={rightCursor}
          reviews={data?.roomReviews || {}}
          roomHighlights={data?.roomHighlights}
        />
      </Modal>

      <Modal
        isOpen={isPlanPoliciesModalOpen}
        closeModal={closePlanPoliciesModal}
        modalStyles={{width: '80rem'}}
        hideCloseButton={true}
      >
        <PlanDetailsPoliciesModal
          roomData={planpolicyModalData}
          onCloseBtnClick={closePlanPoliciesModal}
        />
      </Modal>
    </>
  );
};

export default ElitPackageContainerUI;
